<div class="address-search-container">
  <form (submit)="addressInputSubmit()">
    <span class="p-input-icon-left">
      <i class="oda-pin pin-icon"></i>
      <input class="text-truncate" type="text" pInputText [(ngModel)]="addressSearchValue" name="addressSearchValue"
        (ngModelChange)='changed($event)' placeholder="{{'delivery.page.hint.text.field' | translate}}" #addressSearch
        style="padding-right: 102px;"
        [ngClass]="{'invalid-p-inputtext': (addressType === eAddrSysFlag.Predefined ? (addressSearchValue && (allPredefinedPlaces | filterAddress:addressSearchValue).length === 0) : locationNotFound) }"
        autocomplete="off">
      <i class="oda-times remove-address" *ngIf="addressSearchValue" (click)="removeAddress()"></i>
      <button type="button" class="search_btn" (click)="searchCurrentLocation()">
        <i class="oda-pointer"></i>
      </button>
    </span>
  </form>

  <div class="pac-container pac-logo hdpi" *ngIf="displayPlaceLayout && placeList.length > 0"
    [ngStyle]="{'display': displayPlaceLayout ? 'unset' : 'none'}">
    <div class="pac-sub">
      <div class="pac-item" *ngFor="let place of placeList" (click)="selectAddress(place.addressId, place.type)">
        <span>{{place.fullAddress}}</span>
      </div>
    </div>
  </div>

  <div class="invalid-feeback" *ngIf="addressType !== eAddrSysFlag.Predefined && locationNotFound">
    <i class="oda-alert"></i> {{'alert.address.selected.cannot.detect.location'| translate }}
  </div>

  <div class="invalid-feeback"
    *ngIf="addressType === eAddrSysFlag.Predefined && addressSearchValue && locationNotFound">
    <i class="oda-alert"></i> {{'no.address.found'| translate }}
  </div>
</div>
